<script>
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    isOnExpandedLayout: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle'],
  methods: {
    toggle() {
      this.$emit('toggle');
    },
  },
};
</script>

<template>
  <button
    v-tooltip.left="isOnExpandedLayout ? $t('CONVERSATION.HEADER.COLLAPSE_LAYOUT') : $t('CONVERSATION.HEADER.EXPAND_LAYOUT')"
    class="flex items-center justify-center w-10 h-10 bg-white/60 dark:bg-slate-800/60 backdrop-blur-md border border-white/20 dark:border-slate-600/30 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:bg-white/90 dark:hover:bg-slate-800/90 hover:border-blue-200/50 dark:hover:border-blue-500/30 text-slate-500 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 group"
    @click="toggle"
  >
    <svg 
      class="w-4 h-4 transition-transform duration-200 group-hover:scale-110" 
      fill="none" 
      stroke="currentColor" 
      viewBox="0 0 24 24"
    >
      <!-- Expand Layout Icon -->
      <path
        v-if="!isOnExpandedLayout"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 3H5a2 2 0 00-2 2v3m2-5h3m0 0v3m0-3L5 8m11-5h3a2 2 0 012 2v3m-2-5h-3m3 0v3m0-3L16 8M3 16v3a2 2 0 002 2h3m-2-2h3m0 0v-3m0 3L8 16m8 0v3a2 2 0 002 2h3m-2-2h-3m3 0v-3m0 3l-3-3"
      />
      <!-- Collapse Layout Icon -->
      <path
        v-else
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
      />
    </svg>
  </button>
</template>
